import React from "react";
import { Quote } from "lucide-react";

const testimonials = [
  {
    name: "Kovács Béla",
    role: "Magánügyfél · Cegléd",
    text: "Vasárnap este 9-kor leoltott a biztosíték. Martin egy órán belül itt volt, megoldotta. Profi, kulturált, ár-érték király.",
  },
  {
    name: "Nagy Krisztina",
    role: "Étterem tulajdonos · Szolnok",
    text: "Egy egész konyha villamoshálózatát újrahúzták egy hét alatt. Tiszta papírmunka, számlák, jegyzőkönyv. Ajánlom a VargaVolt-ot.",
  },
  {
    name: "Sz. Tamás",
    role: "Logisztikai vezető · Gödöllő",
    text: "Az ipari karbantartást rájuk bíztuk. Eddig 0 leállás. Az AI hibadiagnosztikájuk meglepően pontos volt.",
  },
];

const gallery = [
  "https://images.pexels.com/photos/7541342/pexels-photo-7541342.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/33694016/pexels-photo-33694016.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/27638181/pexels-photo-27638181.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/28265032/pexels-photo-28265032.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export default function References() {
  return (
    <section data-testid="references-section" className="border-b border-[#262626]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="font-mono text-xs text-[#FFD700] uppercase tracking-[0.4em] mb-3">
          [ 04 / Referenciák ]
        </div>
        <h2 className="font-heading uppercase text-4xl md:text-6xl leading-none mb-12">
          Ezt mondják <span className="text-[#FFD700]">rólunk.</span>
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-7 grid grid-cols-2 gap-4">
            {gallery.map((url, i) => (
              <div
                key={i}
                data-testid={`gallery-img-${i}`}
                className="aspect-square overflow-hidden border-2 border-[#262626] relative group"
              >
                <img
                  src={url}
                  alt={`Munka ${i + 1}`}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500"
                />
                <div className="absolute bottom-2 left-2 bg-black/80 px-2 py-1 font-mono text-xs text-[#FFD700] border border-[#FFD700]">
                  #{String(i + 1).padStart(3, "0")}
                </div>
              </div>
            ))}
          </div>

          <div className="lg:col-span-5 flex flex-col gap-4">
            {testimonials.map((t, i) => (
              <div
                key={i}
                data-testid={`testimonial-${i}`}
                className="card relative"
              >
                <Quote className="w-8 h-8 text-[#FFD700] mb-3" />
                <p className="font-mono text-sm text-[#F5F5F5] leading-relaxed">&ldquo;{t.text}&rdquo;</p>
                <div className="mt-4 pt-4 border-t border-[#262626]">
                  <div className="font-heading uppercase text-sm">{t.name}</div>
                  <div className="font-mono text-xs text-[#A3A3A3]">{t.role}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
